<template>
  <div class="metas p-2 mt-1 mb-3 text-white">
    <b-row>
      <b-col cols="3">
        <h3 class="m-0 p-0 text-right">Status</h3>
      </b-col>
      <b-col cols="7" class="text-right">
        <b-select
          :options="listaStatus"
          name="Status"
          id="Status"
          v-model="statusSelect"
          placeholder="Sem Filtro"
          @change="disparaFiltroPreCotacao"
        ></b-select>
      </b-col>
       <b-col cols="2">
        <button
          @click="mostralModalFiltro = true"
          type="button"
          class="btn btn-primary btn-copy-link"
        >
          <i class="fa fa-filter"></i>
        </button>
      </b-col>
    </b-row>
     <b-modal
      v-model="mostralModalFiltro"
      :active.sync="mostralModalFiltro"
      hide-footer
      centered
      title="Filtrar Pre-Cotações por:"
      class="modalFiltro"
    >
      <div class="container-filtro">
        <p>Placa</p>
        <the-mask
          mask="AAA-#XX#"
          style="text-transform: uppercase"
          id="input-2"
          class="form-control"
          v-model="formFiltro.placa"
          name="Placa"
          :masked="true"
        />
        <p>Nome</p>
        <b-form-input v-model="formFiltro.nome"></b-form-input>
        <p>Email</p>
          <b-form-input
            id="Email"
            name="Email"
            v-model="formFiltro.email"
            v-validate="{ email: true, required: false }"
            :state="validateState('Email')"
          ></b-form-input>
          <p>Celular</p>
          <the-mask
            mask="(##) # ####-####"
            style="text-transform: uppercase"
            id="Celular"
            name="Celular"
            class="form-control"
            v-model="formFiltro.celular"
            :masked="true"
            :state="validateState('Celular')"
            :class="validateClass('Celular')"
          />
        <p>Código</p>
        <b-form-input v-model="formFiltro.codigo"></b-form-input>
      </div>

      <b-row>
        <b-col class="d-flex justify-content-end mt-3">
        <button
          @click="resetaFiltros"
          type="button"
          class="btn btn-danger btn-copy-link"
        >
          <i class="fa fa-trash"></i>
        </button>
      </b-col>
        <b-col class="d-flex justify-content-end mt-3">
          <b-button @click="emitirFiltroPreCotacoes()" pill variant="primary"
            >Filtrar</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<!-- eslint-disable -->
<script>
import service from "../services";
import locale from './../locale';
export default {
  name: "FiltroPreCotação",
  props: {
    msg: String,
    semFiltro: Number
  },
  watch: {
    semFiltro: function (newValue){
      newValue > 0 && this.trocarStatusParaSemFiltro()
    }
  },
  data() {
    return {
      value: 80,
      max: 100,
      listaStatus: [{value: null, text: 'Sem Filtro'},{value: 'Não Convertida',text:'Não Convertida'},{value:'Convertida', text:'Convertida'}],
      statusSelect: null,
      mostralModalFiltro: false,
      formFiltro: {
        placa: null,
        nome: null,
        email: null,
        celular: '',
        codigo: null,
      },
    };
  },
  methods: {
    disparaFiltroPreCotacao() {
      this.$emit("filtroStatusPreCotacao", this.statusSelect);
    },
    resetaFiltros(){
      this.formFiltro =  {
        placa: null,
        nome: null,
        email: null,
        celular: '',
        codigo: null,
      }
      this.mostralModalFiltro = false
      this.$emit('FiltroPreCotacoesEmitido', this.formFiltro)
    },
     emitirFiltroPreCotacoes() {
      this.$emit('FiltroPreCotacoesEmitido', this.formFiltro);
      this.mostralModalFiltro = false;
    },
    trocarStatusParaSemFiltro(){
      this.statusSelect = null
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        if (!this.veeErrors.has(ref) == false) {
          return 'border border-danger ';
        } else {
          return 'border border-success ';
        }
      }
      return null;
    },
    popToast() {
      // Use a shorter name for this.$createElement
      const h = this.$createElement;

      var msg = '';
      var arrMsg = this.$validator.errors.all();
      var arrAux = [];
      arrMsg.forEach((element) => {
        arrAux.push(h('p', {}, element));
      });
      // Create the message
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, arrAux);

      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: 'Atenção!',
        solid: true,
        variant: 'danger',
        toaster: 'b-toaster-top-full',
        appendToast: false,
        autoHideDelay: 2500,
      });
    },
  },
  mounted() {
    this.$validator.localize('en', locale)
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.metas {
  font-size: 11px;
  background-color: black;
  border-radius: 10px;
}
.iconeChart {
  width: 50px;
  height: 50px;
  text-align: center;
  vertical-align: middle;
  font-size: 18px;
  background-color: slategrey;
}
.avatar {
  width: 80px;
  height: 80px;
  /*position: relative;*/
}
.nota {
  margin-top: -10px;
  /* clear: both;
  position: relative;*/
}
.metas h3 {
  font-size: 15px;
  font-weight: bold;
}

.metas h5 {
  font-size: 11px;
}
.modalFiltro {
  position: relative;
  z-index: 9999 !important;
}
</style>
<style lang="scss" scoped>
.container-filtro {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  p {
    margin: 0;
  }
}
</style>
